export const FORM_LEAVE_MESSAGE = "You haven't saved a draft. Leave without saving a draft?"

const activeGuards = []

export function registerFormLeaveGuard(guard) {
  activeGuards.push(guard)
}

export function unregisterFormLeaveGuard(guard) {
  const index = activeGuards.lastIndexOf(guard)
  if (index >= 0) {
    activeGuards.splice(index, 1)
  }
}

function getActiveFormLeaveGuard() {
  return activeGuards.length ? activeGuards[activeGuards.length - 1] : null
}

export function confirmFormLeaveIfNeeded() {
  const guard = getActiveFormLeaveGuard()
  if (!guard || guard.formLeaveConfirmed || !guard.isFormDirty()) {
    return true
  }
  if (window.confirm(FORM_LEAVE_MESSAGE)) {
    guard.formLeaveConfirmed = true
    return true
  }
  return false
}
